import importAssets from 'helper/import-assets';
import prepareLocales from 'ui/i18n/loader';

import type { LoadedLocales } from 'ui/i18n/types';

export default prepareLocales(importAssets(require.context('./files', true, /\.\/.*\.json$/)) as LoadedLocales);
